






import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { Customer, emptyCustomer } from '@/services/models'
import { Action, Getter } from 'vuex-class'

@Component
export default class CustomerSelector extends Vue {

  @Prop({
    default: '',
  })
  private value!: string|null

  @Getter('firestore/customers')
  private customers!: Customer[]

  @Action('firestore/fetchCustomers')
  private fetchCustomers!: () => Promise<any>

  private get options(): Array<{ value: string, text: string }> {
    return this.customers && this.customers.map((c) => ({
      value: c.code,
      text: c.name,
    }))
  }

  public mounted() {
    this.fetchCustomers()
  }

  @Emit()
  public input(customerId: string) {
    // pass
    const o = this.customers.find((c) => c.code === customerId)
    this.selected(o)
  }

  @Emit('selected')
  public selected(customer?: Customer) {
    // pass
  }
}
